// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  CachedCustomerMerge,
  CachedCustomerMergeItem,
} from '@/audit/api/types';
import { AuditMergedEntityLabel } from '@/audit/components/audit-merged-entity-label';

interface Props {
  property: CachedCustomerMerge;
}

const keyLabels: Record<keyof CachedCustomerMergeItem, string> = {
  billingAddress: 'Billing address',
  billingContactEmail: 'Billing contact email',
  billingContactName: 'Billing contact name',
  billingContactPhone: 'Billing contact phone',
  comment: 'Comment',
  externalId: 'External ID',
  id: 'Identifier',
  isArchived: 'Archived',
  isCustomer: 'Is customer',
  isSupplier: 'Is supplier',
  key: 'Key',
  name: 'Name',
};

export function AuditMergedCustomerEntityLabel(props: Props) {
  const result = props.property.newValue!; // Only new value is set for this prop

  return (
    <AuditMergedEntityLabel
      title="Merged customer:"
      result={result}
      keyLabels={keyLabels}
      pinnedKeys={['name']}
      ignoredKeys={['id', 'key']}
      emptyValueLabel="None"
    />
  );
}
